import React from "react";

const Banner = () => {
  return (
    <header className="home-banner">
      <img src="/banner.jpg" alt="banner-bg" className="banner-bg" />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9 col-12">
            <div className="banner-con">
              <h1>about global media and connectivity</h1>
              <p className="para">
                Lorem Ipsum has been the industry's standard dummy text ever
                since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </p>
              <a href="/contact" className="main-btn red-btn">
                <span>Let’s connect</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Banner;
